'use strict';

var globalMessageListeners = require('widget/scripts/lib/commons/globalMessageListeners'),
    widgetMessagingChannels = require('widget/scripts/lib/commons/widgetMessagingChannels'),
    widgetStateManager = require('widget/scripts/lib/commons/widgetStateManager');

// TODO: write unit tests
module.exports = function () {
    var widget = this;

    // unregister all global listeners
    globalMessageListeners.unregisterListener(widget.id, '**');
    // remove messaging channel
    widgetMessagingChannels.destroy(widget.id);
    // remove reference from widgetStateManager by setting widget as free
    widgetStateManager.setFree(widget.id);
    // remove widget node from DOM
    widget.node.remove();

    // mark widget as destroyed
    Object.defineProperty(widget, 'isDestroyed', {
        value: true
    });

    //return null instead of this to break any further chaining
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/api/destroy.js
// module id = 15
// module chunks = 0 1